import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOTagsProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  twitterCard?: string;
  twitterTitle?: string;
  twitterDescription?: string;
  twitterImage?: string;
  schema?: string;
}

const SEOTags: React.FC<SEOTagsProps> = ({
  title = 'Pokémon Card Index - Comprehensive Pokémon TCG Database',
  description = 'Explore the complete Pokémon Trading Card Game database. Search cards, view prices, track collections, and discover the most valuable Pokémon cards.',
  canonicalUrl = 'https://pokecardindex.com',
  ogTitle,
  ogDescription,
  ogImage = 'https://pokecardindex.com/og-image.jpg',
  ogType = 'website',
  twitterCard = 'summary_large_image',
  twitterTitle,
  twitterDescription,
  twitterImage = 'https://pokecardindex.com/twitter-image.jpg',
  schema
}) => {
  return (
    <Helmet>
      {/* Standard meta tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph meta tags */}
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content={ogType} />

      {/* Twitter Card meta tags */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={twitterTitle || title} />
      <meta name="twitter:description" content={twitterDescription || description} />
      <meta name="twitter:image" content={twitterImage} />

      {/* Schema.org markup */}
      {schema && (
        <script type="application/ld+json">
          {schema}
        </script>
      )}
    </Helmet>
  );
};

export default SEOTags; 